import { api } from '@/lib/api'

/** @typedef {import('@/types/api').WalkinQueueEntry} WalkinQueueEntry */

/**
 * @returns {Promise<WalkinQueueEntry[]>}
 */
export async function fetchWalkinQueue() {
  const { data } = await api.get('/walkin-queue')
  return data.data.entries
}

/**
 * @param {Record<string, unknown>} payload
 * @returns {Promise<WalkinQueueEntry>}
 */
export async function addWalkinQueueEntry(payload) {
  const { data } = await api.post('/walkin-queue', payload)
  return data.data.entry
}

/**
 * @param {number[]} orderedEntryIds
 * @returns {Promise<WalkinQueueEntry[]>}
 */
export async function reorderWalkinQueue(orderedEntryIds) {
  const { data } = await api.post('/walkin-queue/reorder', {
    ordered_entry_ids: orderedEntryIds,
  })
  return data.data.entries
}

/**
 * @param {number} entryId
 * @param {{ stylist_id?: number | null, chair_id?: number | null }} payload
 * @returns {Promise<WalkinQueueEntry>}
 */
export async function assignWalkinQueueEntry(entryId, payload) {
  const { data } = await api.post(`/walkin-queue/${entryId}/assign`, payload)
  return data.data.entry
}
